export default __webpack_public_path__ + "static/media/7.7e6f849b.png";